export default function BotCatalogBadge({ onClick, disabled = false, hint = 'válido 20 min' }) {
  return (
    <button
      type="button"
      className="crm-bf-catalog-badge"
      onClick={onClick}
      disabled={disabled}
      title="Abrir catálogo personal"
    >
      <span className="crm-bf-catalog-badge__icon" aria-hidden="true">
        🛒
      </span>
      <span className="crm-bf-catalog-badge__label">Catálogo</span>
      {hint ? <span className="crm-bf-catalog-badge__hint">{hint}</span> : null}
    </button>
  );
}
